
<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="currentItem==null">
    <h1 class="content-heading-font">Users</h1>


    <div class="row" *ngIf="currentItem==null">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                 sortField="UserName" [sortOrder]="1">


          <ng-template pTemplate="header">
            <tr>
              <th class="text-end" style="width:100px;"></th>
              <th pSortableColumn="ID" class="text-end d-none d-xl-table-cell">#<p-sortIcon field="ID"></p-sortIcon></th>
              <th pSortableColumn="UserName" class="text-start">
                User
                <p-sortIcon field="UserName"></p-sortIcon>
                <p-columnFilter type="text" field="UserName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="FullName" class="text-star d-none d-lg-table-cell">
                Name <p-sortIcon field="FullName"></p-sortIcon>
                <p-columnFilter type="text" field="FullName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th class="text-star d-none d-xl-table-cell">
                User Type
                <p-columnFilter field="UserTypes" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" [options]="arkUserTypes" placeholder="Any" (onChange)="filter($event.value)" optionValue="value" optionLabel="text" [filter]="false">
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="LastLoginDate" class="text-star d-none d-xl-table-cell">
                Last Login<p-sortIcon field="LastLoginDate"></p-sortIcon>
                <p-columnFilter type="date" field="LastLoginDate" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="OpenTickets" class="text-end d-none d-md-table-cell">
                Tickets <p-sortIcon field="OpenTickets"></p-sortIcon>
                <p-columnFilter type="numeric" field="OpenTickets" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-end">
                <div class="gap-2 d-block text-">

                  <a class="btn btn-sm btn-primary me-1 " (click)="onRowEditInit(item)" title="Edit">
                    <i class="pi pi-pen-to-square"></i>
                  </a>
                  <a class="btn btn-sm btn-warning  " (click)="onRowDeleteInit(item)" title="Delete">
                    <i class="pi pi-trash"></i>
                  </a>
                </div>
              </th>
              <th class="text-end d-none d-xl-table-cell">{{ item.ID }}</th>
              <td>
                <img [src]="item.ProfileImageURL" class="smallProfileImage d-none d-lg-inline-block" *ngIf="item.ProfileImageURL" />
                {{ item.UserName }}
              </td>
              <td class=" d-none d-lg-table-cell">{{ item.FullName }}</td>
              <td class=" d-none d-xl-table-cell">{{getDisplayValue(item.UserTypes)}}</td>
              <td class=" d-none d-xl-table-cell">
                <a href="https://ipinfo.io/{{item?.LastLoginIp}}" target="ipinfo">
                  {{item?.LastLoginDate  | date:'medium'}}
                </a>
                <a *ngIf="item?.LastLoginLatLon" href="https://www.google.com/maps/place/{{item?.LastLoginLatLon}}" class="pi pi-map-marker ms-2" style="font-size: 12px" target="googlemap"></a>
              </td>

              <td class="text-end d-none d-md-table-cell">
                <a href="#" [routerLink]="['/tickets']" [queryParams]="{userID: item.ID}">
                  {{ item.CriticalTickets |  number  }} / {{ item.OpenTickets |  number }}
                </a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary " (click)="addItem(dt1)" title="Add item">
              <i class="pi pi-plus"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="loadTable(null)" title="Refress">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No items found.</td>
            </tr>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>

  <div class="main-page-content-block" *ngIf="currentItem!=null">
    <div class="float-end">
      <a class="btn btn-secondary" (click)="cancel()">View list</a>
    </div>

    <h1 class="content-heading-font">{{currentItem.UserName }}</h1>
    <form #itemForm="ngForm" [formGroup]="itemFormGroup">
      <div class="row">
        <div class="col mb-3">
          <label for="UserName">Username</label>
          <input class="form-control" name="UserName" formControlName="UserName" autocomplete="off" placeholder="Username" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="FirstName">First Name</label>
          <input class="form-control" name="FirstName" formControlName="FirstName" autocomplete="off" placeholder="FirstName" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="LastName">Last Name</label>
          <input class="form-control" name="LastName" formControlName="LastName" autocomplete="off" placeholder="LastName" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Email">Email</label>
          <input class="form-control" name="Email" formControlName="Email" autocomplete="off" placeholder="Email" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="PhoneNumber">Phone Number</label>
          <input class="form-control" name="PhoneNumber" formControlName="PhoneNumber" autocomplete="off" placeholder="PhoneNumber" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="GitHub_Username">GitHub Username </label>
          <input class="form-control" name="GitHub_Username" formControlName="GitHub_Username" placeholder="" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="GitHub_AccessToken">GitHub AccessToken </label>
          <input class="form-control" name="GitHub_AccessToken" formControlName="GitHub_AccessToken" placeholder="" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Teamcity_AccessToken">Teamcity AccessToken </label>
          <input class="form-control" name="Teamcity_AccessToken" formControlName="Teamcity_AccessToken" placeholder="" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="NotificationOnNewSupportTicket">Notification On New Support Ticket  </label>
          <select class="form-control" name="NotificationOnNewSupportTicket" formControlName="NotificationOnNewSupportTicket">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="ValidIPAddresses">Valid IP Addresses</label>
          <input class="form-control" name="ValidIPAddresses" formControlName="ValidIPAddresses" placeholder="0.0.0.0" />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col mb-3">
          <label for="UserTypes">User type</label>
          <p-listbox [options]="arkUserTypes"
                     formControlName="UserTypes"
                     optionLabel="text"
                     optionValue="value"
                     [filter]="false"
                     [multiple]="true"
                     [checkbox]="true"
                     styleClass="col "
                     listStyleClass=""
                     [showToggleAll]="false"
                     class="flat-listbox"></p-listbox>

        </div>
      </div>


      <div class="row mb-2">
        <div class="col mb-3">
          <div for="UserHasClients" class="mb-1 align-items-baseline">
            User Has Clients: <button class="ms-2 btn btn-outline-primary   " (click)="addUserHasClient()" title="Add item" type="button"><i class="pi pi-plus"></i></button>
          </div>
          <ng-container formArrayName="UserHasClients">
            <ng-container *ngFor="let userHasClientsForm of UserHasClients.controls; let i = index">
              <table class="w-100 mb-1" [formGroupName]="i">
                <tr>
                  <td>
                    <div class="row">
                      <div class="col-6">
                        <label for="ClientID">Client:</label>
                        <select name="ClientID" formControlName="ClientID" autocomplete="off" [class.div-loading]="loadingClients" class="form-control" (change)="clientSelected(userHasClientsForm)">
                          <option *ngFor="let client of clients" [ngValue]="client.ID">
                            {{client.SiteName}}
                            {{client.Active?'':'[Inactive]'}}
                          </option>
                        </select>


                      </div>
                      <div class="col-6">
                        <label for="Client_Username">Username:</label>
                        <input class=" form-control" name="Client_Username" formControlName="Client_Username" autocomplete="off" />
                      </div>
                    </div>
                  </td>
                  <td style="width: 50px;vertical-align:bottom; text-align:right">
                    <button class="btn  btn-outline-danger" (click)="deleteUserHasClient(i)" title="Remove item" type="button"><i class="pi pi-trash"></i></button>
                  </td>
                </tr>
              </table>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary" type="submit" id="btnSave" [class.button-loading]="loading" (click)="save()">Save</button>
        </div>
      </div>
    </form>

  </div>

  <div class="main-page-content-block-secondary  mt-3 " *ngIf="currentItem!=null && currentItem.ID ">

    <h1 class="content-heading-font">Authentication</h1>

    <p>
      Has One Time Password Key : <span class="text-success" *ngIf="currentItem?.HasOneTimePasswordKey">Yes</span><span class="text-danger" *ngIf="!currentItem?.HasOneTimePasswordKey">No</span><br />
      Has Web Authn Key : <span class="text-success" *ngIf="currentItem?.WebAuthnCredentialId">Yes</span><span class="text-danger" *ngIf="!currentItem?.WebAuthnCredentialId">No</span><br />
      Password Expire Date :
      <span class="text-success" *ngIf="currentItem?.PasswordExpireDate && !isPasswordExpired()">{{currentItem?.PasswordExpireDate | date:'medium' }}</span>
      <span class="text-danger" *ngIf="isPasswordExpired()">{{currentItem?.PasswordExpireDate | date:'medium' }} (Expired)</span>
      <span class="text-warning" *ngIf="!currentItem?.PasswordExpireDate">Never</span>
      <br />
    </p>
    <p *ngIf="currentItem?.LastLoginDate">
      Last Login: {{currentItem?.LastLoginDate  | date:'medium'}} at <a href="https://ipinfo.io/{{currentItem?.LastLoginIp}}" target="ipinfo">{{currentItem?.LastLoginIp}}</a>
      <a *ngIf="currentItem?.LastLoginLatLon" href="https://www.google.com/maps/place/{{currentItem?.LastLoginLatLon}}" class="pi pi-map-marker ms-2" style="font-size: 12px" target="googlemap">
      </a><br />
      Auth Expire : {{currentItem?.AuthExpireDate | date:'medium' }}<br />
    </p>

    <div class="row">
      <div class="col text-center">
        <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnReset2Factor" [class.button-loading]="loading" *ngIf="currentItem.HasOneTimePasswordKey" (click)="resetTwoFactor()">Reset 2-factor</button>
        <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnResetPassword" [class.button-loading]="loading"  (click)="resetPassword()">Reset password</button>
      </div>
    </div>
  </div>
</div>


<p-dialog header="Reset password" [modal]="true" [(visible)]="resetPasswordVisible"  >
  <div class="row">
    <div class="col mb-3">
      <label for="newPassword">New password</label>
      <input class="form-control" name="newPassword" autocomplete="off" [(ngModel)]="newPassword" />
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnPasswordConfirm" [class.button-loading]="loading" (click)="resetPasswordConfirm()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnPasswordCance" [class.button-loading]="loading" (click)="resetPasswordVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>
